"use client";
import React, { useEffect, useState } from "react";
import "../styles/address.css";

export default function AddressStep() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [addresses, setAddresses] = useState([
    {
      id: 1,
      type: "Home",
      name: "Shubham Muneshwar",
      mobile: "9876543210",
      line1: "Flat No 302, Sai Residency",
      line2: "MG Road",
      landmark: "Near Metro Station",
      city: "Bangalore",
      state: "Karnataka",
      country: "India",
      postalCode: "560001",
    },
  ]);

  const [selectedId, setSelectedId] = useState(1);

  const [showForm, setShowForm] = useState(false);

  const [error, setError] = useState("");

  const [form, setForm] = useState({
    type: "",
    name: "",
    mobile: "",
    line1: "",
    line2: "",
    landmark: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
  });

  const handleChange = (field, value) => {
    // Mobile validation: allow only digits, max 10
    if (field === "mobile") {
      const cleaned = value.replace(/\D/g, "");

      if (cleaned.length <= 10) {
        setForm({ ...form, mobile: cleaned });
      }
      return;
    }

    setForm({ ...form, [field]: value });
  };

  const validateForm = () => {
    if (!form.name) return "Contact name required";

    if (!/^\d{10}$/.test(form.mobile))
      return "Mobile number must be exactly 10 digits";

    if (!form.line1) return "Address Line 1 required";

    if (!form.city) return "City required";

    if (!form.state) return "State required";

    if (!form.country) return "Country required";

    if (!form.postalCode) return "Postal Code required";

    return "";
  };

  const handleSave = () => {
    const validationError = validateForm();

    if (validationError) {
      setError(validationError);
      return;
    }

    const newAddress = {
      id: Date.now(),
      ...form,
    };

    setAddresses([...addresses, newAddress]);

    setSelectedId(newAddress.id);

    setShowForm(false);

    setError("");

    setForm({
      type: "",
      name: "",
      mobile: "",
      line1: "",
      line2: "",
      landmark: "",
      city: "",
      state: "",
      country: "",
      postalCode: "",
    });
  };

  return (
    <div className="address-container">
      <h2>Select Delivery Address</h2>

      {/* ADDRESS LIST */}
      {addresses.map((addr) => (
        <div
          key={addr.id}
          className={`address-card ${selectedId === addr.id ? "selected" : ""}`}
        >
          <div>
            <div className="address-type">{addr.type}</div>

            <div className="address-name">
              {addr.name} • {addr.mobile}
            </div>

            <div className="address-text">{addr.line1}</div>

            {addr.line2 && <div className="address-text">{addr.line2}</div>}

            {addr.landmark && (
              <div className="address-landmark">Landmark: {addr.landmark}</div>
            )}

            <div className="address-text">
              {addr.city}, {addr.state}
            </div>

            <div className="address-text">
              {addr.country} - {addr.postalCode}
            </div>
          </div>

          <button
            className="deliver-btn"
            onClick={() => setSelectedId(addr.id)}
          >
            {selectedId === addr.id ? "Selected" : "Deliver Here"}
          </button>
        </div>
      ))}

      {/* ADD BUTTON */}
      {!showForm && (
        <button className="add-address-btn" onClick={() => setShowForm(true)}>
          + Add New Address
        </button>
      )}

      {/* FORM */}
      {showForm && (
        <div className="address-form">
          <input
            placeholder="Address Type (Home / Office)"
            value={form.type}
            onChange={(e) => handleChange("type", e.target.value)}
          />

          <input
            placeholder="Contact Person Name *"
            value={form.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />

          <input
            placeholder="Mobile Number (10 digits) *"
            value={form.mobile}
            onChange={(e) => handleChange("mobile", e.target.value)}
          />

          <input
            placeholder="Address Line 1 *"
            value={form.line1}
            onChange={(e) => handleChange("line1", e.target.value)}
          />

          <input
            placeholder="Address Line 2"
            value={form.line2}
            onChange={(e) => handleChange("line2", e.target.value)}
          />

          <input
            placeholder="Landmark"
            value={form.landmark}
            onChange={(e) => handleChange("landmark", e.target.value)}
          />

          <input
            placeholder="City *"
            value={form.city}
            onChange={(e) => handleChange("city", e.target.value)}
          />

          <input
            placeholder="State *"
            value={form.state}
            onChange={(e) => handleChange("state", e.target.value)}
          />

          <input
            placeholder="Country *"
            value={form.country}
            onChange={(e) => handleChange("country", e.target.value)}
          />

          <input
            placeholder="Postal Code *"
            value={form.postalCode}
            onChange={(e) => handleChange("postalCode", e.target.value)}
          />

          {error && <div className="address-error">{error}</div>}

          <div className="form-buttons">
            <button className="cancel-btn" onClick={() => setShowForm(false)}>
              Cancel
            </button>

            <button className="save-btn" onClick={handleSave}>
              Save Address
            </button>
          </div>
        </div>
      )}

      <button className="continue-btn">Continue to Payment</button>
    </div>
  );
}
